import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BookIcon } from './icons/index.js';
/**
 * Unit banner shown above the path. Two split cards (left main + right
 * guidebook), matching the production layout: 82px tall, gap 2px, rounded
 * outer corners.
 */
export function UnitBanner({ eyebrow, title, color, onGuideClick }) {
    return (_jsxs("div", { className: "sl-unit-banner", style: { ['--sl-unit-color']: color }, children: [_jsxs("button", { type: "button", className: "sl-unit-banner__main", children: [_jsx("span", { className: "sl-unit-banner__eyebrow", children: eyebrow }), _jsx("span", { className: "sl-unit-banner__title", children: title })] }), _jsx("button", { type: "button", className: "sl-unit-banner__guide", onClick: onGuideClick, "aria-label": "Abre o guia da unidade", children: _jsx(BookIcon, { size: 24 }) })] }));
}
//# sourceMappingURL=UnitBanner.js.map